import React from 'react';
import PropTypes from 'prop-types';
import authHelper from 'helpers/auth';
import BookingReservationOrderIdFilter from 'components/form/filters/BookingReservationOrderIdFilter';
import CancelledAtFilter from 'components/form/filters/CancelledAtFilter';
import CategoryIdFilter from 'components/form/filters/CategoryIdFilter';
import CreatedAtFilter from 'components/form/filters/CreatedAtFilter';
import DestinationArrivalDateFilter from 'components/form/filters/DestinationArrivalDateFilter';
import DestinationDepartureDateFilter from 'components/form/filters/DestinationDepartureDateFilter';
import EmailFilter from 'components/form/filters/EmailFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import FunnelIdFilter from 'components/form/filters/FunnelIdFilter';
import LastNameFilter from 'components/form/filters/LastNameFilter';
import LicensePlateFilter from 'components/form/filters/LicensePlateFilter';
import MultiProviderIdFilter from 'components/form/filters/MultiProviderIdFilter';
import MultiResellerIdFilter from 'components/form/filters/MultiResellerIdFilter';
import PaymentStatusFilter from 'components/form/filters/PaymentStatusFilter';
import PhoneFilter from 'components/form/filters/PhoneFilter';
import ProductIdFilter from 'components/form/filters/ProductIdFilter';
import ReservationStatusFilter from 'components/form/filters/ReservationStatusFilter';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import SubCategoryIdFilter from 'components/form/filters/SubCategoryIdFilter';
import TestBookingFilter from 'components/form/filters/TestBookingFilter';
import TextFilter from 'components/list/Filters/types/TextFilter';
import BooleanFilter from 'components/form/filters/BooleanFilter';

const BookingOrderIdFilter = <TextFilter
    label='filters.components.bookingOrderId.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='order_id'
/>;

const BookingsListFilters = (props) => {
    const filters = {
        basic: {
            reservation_status: {
                component: ReservationStatusFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            license_plate: {
                component: LicensePlateFilter,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            last_name: {
                component: LastNameFilter,
                matchTypes: {
                    default: filterMatchTypes.startsWith,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            booking_reservation_order_id: {
                component: BookingReservationOrderIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
        advanced: {
            created_at: {
                component: CreatedAtFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            destination_arrival_date: {
                component: DestinationArrivalDateFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            destination_departure_date: {
                component: DestinationDepartureDateFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            category_id: {
                component: CategoryIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            subcategory_id: {
                component: SubCategoryIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            email: {
                component: EmailFilter,
                matchTypes: {
                    default: filterMatchTypes.equals,
                    values: [
                        filterMatchTypes.equals,
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            is_rebooked: {
                component: <BooleanFilter source='is_rebooked' label='filters.components.is_rebooked.label' />,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            order_id: {
                component: BookingOrderIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
    };

    if (authHelper.isAdmin()) {
        filters.advanced.reseller_id = {
            component: MultiResellerIdFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.matchOneOf,
                ],
            },
        };

        filters.advanced.provider_id = {
            component: MultiProviderIdFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.matchOneOf,
                ],
            },
        };

        filters.advanced.phone = {
            component: PhoneFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.equals,
                ],
            },
        };
    }

    if (!authHelper.isProvider()) {
        filters.advanced.is_test_order = {
            component: TestBookingFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.equals,
                ],
            },
        };

        filters.advanced.payment_status = {
            component: PaymentStatusFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.matchOneOf,
                ],
            },
        };

        filters.advanced.cancelled_at = {
            component: CancelledAtFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.between,
                ],
            },
        };

        filters.advanced.funnel_id = {
            component: FunnelIdFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.equals,
                ],
            },
        };
    }

    if (!authHelper.isReseller()) {
        filters.advanced.product_id = {
            component: ProductIdFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.matchOneOf,
                ],
            },
        };
    }

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

BookingsListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default BookingsListFilters;



// WEBPACK FOOTER //
// ./src/pages/bookings/list/BookingsListFilters.js